// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__6GhdM","info":"PatientInfo_info__QJqno"};